import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import CssBaseline from '@material-ui/core/CssBaseline';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/core/styles';

const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#42738D',
        },
        secondary: {
            main: '#E48A0A',
            contrastText: 'white',
        },
    },
    typography: {
        fontFamily: [
            "'Roboto'",
            '"sans-serif"',
        ].join(','),
    }
});

//CRITICAL: DEPLOYMENT SETTINGS - THESE MUST BE UPDATED PRIOR TO ROLLOUT
const app_url_lower = window.location.href.toLowerCase();
const app_virtual_path = '/members';
const url_split_index_for_api = app_url_lower.indexOf(app_virtual_path);
const base_api_path = app_url_lower.substring(0, (url_split_index_for_api + 1));
const base_app_url = app_url_lower.substring(0, (url_split_index_for_api + app_virtual_path.length));

//CRITICAL: DEPLOYMENT SETTINGS - THESE MUST BE UPDATED PRIOR TO ROLLOUT
/* const app_url_lower = window.location.href.toLowerCase();
const app_virtual_path = '';
const url_split_index_for_api = app_url_lower.indexOf(app_virtual_path);
const base_api_path = 'http://localhost:58155/';
const base_app_url = 'http://localhost:3000'; */

ReactDOM.render(
    <ThemeProvider theme={theme}>
        <CssBaseline />
        <App
            baseapiurl={base_api_path}
            base_url={base_app_url}
            googlemapskey={'AIzaSyBuXTEEWWr-Cg4HhHHK96NytFfpTkTA384'}
            base_name={app_virtual_path}
            ga_trackingid={'G-5XHWHX1DZS'}
        />
    </ThemeProvider>,
    document.getElementById('root')
);

// DEV SETTINGS: 
//const app_url_lower = window.location.href.toLowerCase();
//const app_virtual_path = '';
//const url_split_index_for_api = app_url_lower.indexOf(app_virtual_path);
//const base_api_path = 'http://localhost:58155/';
//const base_app_url = 'http://localhost:3000';
// CRITICAL NOTE: SET  "homepage": ".", in package.json

// DEMO SETTINGS (NOTE: base_name should be blank UNLESS the site is being hosted on a sub-directory on the server):
//const app_url_lower = window.location.href.toLowerCase();
//const app_virtual_path = '/membersearch_react';
//const url_split_index_for_api = app_url_lower.indexOf(app_virtual_path);
//const base_api_path = app_url_lower.substring(0, (url_split_index_for_api + 1));
//const base_app_url = app_url_lower.substring(0, (url_split_index_for_api + app_virtual_path.length));
// CRITICAL NOTE: SET  "homepage": "https://www.sartdemo.com/membersearch_react/", in package.json

// PROD SETTINGS: (NOTE: base_name should be blank UNLESS the site is being hosted on a sub-directory on the server):
//const app_url_lower = window.location.href.toLowerCase();
//const app_virtual_path = '/members';
//const url_split_index_for_api = app_url_lower.indexOf(app_virtual_path);
//const base_api_path = app_url_lower.substring(0, (url_split_index_for_api + 1));
//const base_app_url = app_url_lower.substring(0, (url_split_index_for_api + app_virtual_path.length));
// CRITICAL NOTE: SET  "homepage": "https://sartcorsonline.com/members/", in package.json


serviceWorker.unregister();